import $ from "cash-dom";

export default (function () {
    $(document).ready(function () {
        if ($("a, button, input").length) {
            $("body").on("keyup", "a, button, input", function (_e) {
                if (_e.which == 9) {
                    $(".tab-focus").removeClass("tab-focus");
                    $(_e.target).addClass("tab-focus");
                }
            });
        }
    });
})();
